export class PageTitleUtil {
	static setTitle(newTitle: string): void {
		document.title = newTitle;
	}

	static getTitle(): string {
		return document.title;
	}
}